module.exports = __webpack_public_path__ + "img/content3.7e43d0ee.jpg";